import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppleMail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5626_43883)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M6.19561 0.0400391H19.1377C22.1787 0.0400391 24.6268 2.48815 24.6268 5.5291V18.4712C24.6268 21.5122 22.1787 23.9603 19.1377 23.9603H6.19561C3.15467 23.9603 0.706543 21.5122 0.706543 18.4712V5.5291C0.706543 2.48815 3.15467 0.0400391 6.19561 0.0400391Z",
				fill: "url(#paint0_linear_5626_43883)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M5.94741 6.8418C5.82138 6.8418 5.70264 6.86354 5.59027 6.90824L7.8411 9.22552L10.1168 11.5843L10.1584 11.6342L10.2248 11.7006L10.2913 11.767L10.4242 11.9082L12.376 13.9099C12.4085 13.9301 12.5027 14.0173 12.5762 14.0541C12.671 14.1015 12.7737 14.1451 12.8796 14.1489C12.9939 14.153 13.1107 14.1203 13.2135 14.0703C13.2905 14.0328 13.3247 13.9791 13.4142 13.9099L15.6733 11.576L17.9574 9.22552L20.1584 6.95808C20.0171 6.88152 19.8606 6.8418 19.6933 6.8418H5.94741ZM5.25804 7.12419C5.01801 7.35162 4.86768 7.69354 4.86768 8.07934V15.6873C4.86768 15.9997 4.96801 16.2835 5.13346 16.5013L5.44907 16.2023L7.79957 13.9182L9.88429 11.8999L9.84276 11.8501L7.55871 9.4996L5.27465 7.1408L5.25804 7.12419ZM20.4574 7.19894L18.2315 9.4996L15.9557 11.8501L15.9142 11.8916L18.082 13.993L20.4325 16.277L20.5737 16.4099C20.7002 16.2068 20.773 15.9567 20.773 15.6873V8.07934C20.773 7.73534 20.6538 7.4234 20.4574 7.19894ZM10.1501 12.174L8.07366 14.1923L5.71485 16.4763L5.41585 16.767C5.57348 16.8686 5.75287 16.9332 5.94741 16.9332H19.6933C19.9271 16.9332 20.1393 16.8432 20.3162 16.7006L20.1667 16.5511L17.8079 14.267L15.6401 12.174L13.6883 14.184C13.5826 14.254 13.512 14.3317 13.4089 14.3794C13.2429 14.4562 13.0609 14.5211 12.8781 14.5183C12.6947 14.5155 12.5149 14.4437 12.3503 14.3628C12.2677 14.3222 12.2237 14.2818 12.1268 14.2006L10.1501 12.174Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_5626_43883",
			x1: 12.8342,
			y1: 23.8643,
			x2: 12.8574,
			y2: .328813,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#70EFFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5770FF"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5626_43883",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(0.666748)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgAppleMail);
export { ForwardRef as ReactComponent };
